// core
import { Component } from '@angular/core';

// campfire
import { PartnerBrandService } from '@campfire-nx/api';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent {
  queryParams: any;

  constructor(public partnerBrandService: PartnerBrandService) {}
}
